module.exports = __webpack_public_path__ + "img/star_one_w.0c2845bc.svg";